export const staticClassNames = {
    STANDALONE: 'standalone',
    FIXED: 'fixed',
};
